import React, { Component } from "react";

import Submit from "../../Users/Payment/Submit";

import Loading from "../../../../components/Common/Loading";
import ErrorSection from "../../../../components/Common/AppErrors";

class SelectPayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addNew: false,
      payments: props.payments || [],
      error: null,
      selectedPayment:
        (props.payment &&
          props.payment.length &&
          (props.payment.find(payment => payment.default === true) ||
            props.payment[0])) ||
        null
    };
  }

  handleAddNew = event => {
    event.preventDefault();
    this.setState({ addNew: true });
  };
  handleCloseNew = (event, response) => {
    event.preventDefault();
    if (response) {
      const { payments } = this.state;
      this.setState({ payments: [response, ...payments] });
    }
    this.setState({ addNew: false });
  };
  handleSelectPayment = () => {
    const { selectedPayment } = this.state;
    const { onSubmitMethod } = this.props;
    if (selectedPayment) {
      onSubmitMethod(selectedPayment);
    }
  };
  onCloseErrorSection = () => {
    this.setState({ error: null });
  };
  browserPayment = () => {
    const { type } = this.props;
    if (type === 2) {
      return (
        <li
          key={9998}
          onClick={() =>
            this.setState({ selectedPayment: "applePay" }, () => {
              this.handleSelectPayment();
            })
          }
        >
          <button id="apple-pay-button">Apple Pay</button>
        </li>
      );
    } else if (type === 3) {
      return (
        <li
          key={9998}
          onClick={() =>
            this.setState({ selectedPayment: "googlePay" }, () => {
              this.handleSelectPayment();
            })
          }
        >
          <button id="apple-pay-button">Google Pay</button>
        </li>
      );
    } else {
      return (
        <li
          key={9998}
          onClick={() =>
            this.setState({ selectedPayment: "microsoftPay" }, () => {
              this.handleSelectPayment();
            })
          }
        >
          <button id="apple-pay-button">Microsoft Pay</button>
        </li>
      );
    }
  };
  renderPayments = () => {
    const { selectedPayment, payments } = this.state;
    const { canMakePayment } = this.props;
    return [
      ...payments.map((payment, index) => (
        <li
          key={index}
          onClick={() =>
            this.setState({ selectedPayment: payment }, () => {
              this.handleSelectPayment();
            })
          }
        >
          <a
            className={`d-flex justify-content-between align-items-center cursor-pointer ${(selectedPayment &&
              selectedPayment.uid &&
              selectedPayment.uid === payment.uid &&
              "active") ||
              ""}`}
          >
            <p>
              {payment.holderName} (********{payment.last4})
            </p>
            {(selectedPayment &&
              selectedPayment.uid &&
              selectedPayment.uid === payment.uid && (
                <div>
                  <div className="visible-xs">
                    <i className="icon icon-ok-green" />
                  </div>
                  <div className="hide-xs">
                    <i className="icon icon-okay-2" />
                  </div>
                </div>
              )) || <noscript />}
          </a>
        </li>
      )),
      (canMakePayment && this.browserPayment()) || <noscript />
    ];
  };

  render() {
    const { addNew, payments, error, loading } = this.state;
    const { onCloseSelectPayment, canMakePayment } = this.props;
    return (
      (error && (
        <ErrorSection message={error} onClickClose={this.onCloseErrorSection} />
      )) ||
      (addNew && <Submit handleCloseSection={this.handleCloseNew} />) || (
        <React.Fragment>
          {/* Header */}
          <div className="head-general with-back">
            <a href="javascript: void(0)" />
            <h4>Select Payment Method</h4>
            <a
              href="javascript: void(0)"
              onClick={onCloseSelectPayment}
              className="close"
            >
              <icon className="icon icon-close" />
            </a>
          </div>
          {/* Header */}

          <div className="row center-sm">
            <div className="col-sm-6">
              <div className="address-list change-payment mt-10px">
                <a className="cursor-pointer" onClick={this.handleAddNew}>
                  <i className="icon icon-close icon-plus" /> Add New
                </a>
                <ul>
                  {((payments || []).length && this.renderPayments()) ||
                    (canMakePayment && this.browserPayment()) || <noscript />}
                </ul>
                {(loading && <Loading />) || <noscript />}
              </div>
            </div>
            {/* .row */}
          </div>
          {/* .change-payment */}
        </React.Fragment>
      )
    );
  }
}

export default SelectPayment;
